import React from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField} from "@mui/material";
import {useTranslation} from "react-i18next";

export interface SubDeviceFormValues {
  subDeviceNo: string
  einstellung: string
  subDeviceSoftwareVn: string
}

interface SubDeviceDialogProps {
  type: "add" | "update",
  /** This function updates the dirty state in the parents component */
  updateDirty: (dirty: boolean) => void,
  subDeviceDefaultValues: SubDeviceFormValues
  validateSubDeviceId: (id: string) => boolean
  submitOperation: (data: SubDeviceFormValues) => void
  disabled?: boolean
}

export default function SubDeviceDialogButton({
                                                type,
                                                subDeviceDefaultValues,
                                                submitOperation,
                                                validateSubDeviceId,
                                                disabled = false,
                                                updateDirty
                                              }: Readonly<SubDeviceDialogProps>) {

  const [open, setOpen] = React.useState(false)
  const [subDevice, setSubDevice] = React.useState<SubDeviceFormValues>(subDeviceDefaultValues)

  const {t} = useTranslation()

  React.useEffect(() => {
    setSubDevice(subDeviceDefaultValues)
  }, [subDeviceDefaultValues])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!validateSubDeviceId(subDevice.subDeviceNo)) {
      alert(t('pages.subDevice.uniqueAlert'))
      return
    }
    submitOperation(subDevice)
    setOpen(false);
    updateDirty(true)
  };

  return (
    <React.Fragment>
      <Button onClick={handleClickOpen} disabled={disabled}>
        {type === "add" ? t('activities.add') : t('activities.edit')}
      </Button>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        fullWidth
        maxWidth={'xl'}
      >
        <DialogTitle>
          {t('pages.subDevice.popUpTitle')}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              id={"subDeviceNo"}
              variant="standard"
              defaultValue={subDeviceDefaultValues.subDeviceNo}
              required
              label={t('pages.subDevice.subDeviceNumber')}
              onChange={(event) => setSubDevice({...subDevice, subDeviceNo: event.target.value})}
            />
            <TextField
              id={"einstellung"}
              variant="standard"
              defaultValue={subDeviceDefaultValues.einstellung}
              required
              label={t('pages.subDevice.settings')}
              onChange={(event) => setSubDevice({...subDevice, einstellung: event.target.value})}
            />
            <TextField
              id={"subDeviceSoftwareVn"}
              variant="standard"
              defaultValue={subDeviceDefaultValues.subDeviceSoftwareVn}
              label={t('pages.subDevice.subDeviceVersion')}
              required
              onChange={(event) => setSubDevice({...subDevice, subDeviceSoftwareVn: event.target.value})}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpen(false);
          }}>{t('activities.cancel')}</Button>
          <Button onClick={() => {
            if (subDevice.subDeviceNo !== "" && subDevice.einstellung !== "" && subDevice.subDeviceSoftwareVn !== "") {
              handleClose()
            } else {
              alert(t('pages.subDevice.fieldsEmpty'))
            }
          }} autoFocus>
            {t('activities.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
